import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const yandexGpt = {
  postFormToYandexGpt: lazyModuleMethod(
    () => import('./postFormToYandexGpt'),
    'default'
  ),
  generateMetaTextArticle: lazyModuleMethod(
    () => import('./generateMetaTextArticle'),
    'default'
  ),
}
